import React, { useState, useEffect } from "react";
import Swiper from "swiper";

const SwiperMain = () => {
  const [swiperData, setSwiperData] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [loading, setLoading] = useState(true);

  const locationId = document
    .querySelector(".flexi-layout")
    .getAttribute("data-history-node-id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/rest/tour-categories`);
        const result = await response.json();

        let resultData = result;
        if (locationId === "29124") {
          resultData = result.filter((item) =>
            item.view_node.includes("san-francisco")
          );
        } else {
          resultData = result.filter((item) =>
            item.view_node.includes("new-york")
          );
        }

        /* const sortedDataArray = resultData.sort((a, b) =>
          a.title.localeCompare(b.title)
        ); */

        setSwiperData(resultData);
        //setSwiperData(sortedDataArray);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [locationId]);

  const initializeSwiper = () => {
    let mySwiper;

    // Destroy existing Swiper instance if it exists
    if (mySwiper) {
      mySwiper.destroy(true, true);
    }

    // Calculate slides per view based on window width
    const slidesPerView = windowWidth < 1024 ? 2 : 4;

    // Create a new Swiper instance with pagination
    mySwiper = new Swiper(".swiper-container-tour", {
      slidesPerView: slidesPerView,
      spaceBetween: windowWidth > 1024 ? 30 : 10,
      grabCursor: true,
      loop: swiperData.length < 4 ? false : true,
      navigation: {
        nextEl: ".swiper-button-next-tour",
        prevEl: ".swiper-button-prev-tour",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // Allow pagination bullets to be clickable
      },
      threshold: 50,
    });
  };

  useEffect(() => {
    if (swiperData) {
      initializeSwiper();
    }
  }, [swiperData]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="custom-swiper">
      {!loading ? (
        <>
          <div className="swiper-container-tour">
            <div className="swiper-wrapper">
              {swiperData &&
                swiperData.map((item, index) => {
                  const imageUrl = item?.field_image_on_landing?.replace(/&amp;/g, "&");
                  
                  return (
                  <div className="swiper-slide" key={index}>
                    <a className="tour-slide--link" href={item?.view_node}></a>
                    <div
                      className={`swiper-slide--text-box${
                        item?.field_text_on_landing ? " has-subtext" : ""
                      }`}
                    >
                      <div className="swiper-slide--title">{item?.title}</div>
                      <div className="swiper-slide--sub">
                        {item?.field_text_on_landing}
                      </div>
                    </div>
                    <div className="swiper-slide--image">
                      <img
                        src={imageUrl}
                        alt={item?.title}
                      />
                    </div>
                  </div>
                )})}
            </div>
          </div>
          {windowWidth > 1024 ? (
            <>
              {swiperData && swiperData.length >= 4 && (
                <div className="swiper-controller">
                  <div className="swiper-button-next-tour">
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 26.07 21.19"
                    >
                      <title>next</title>
                      <path
                        id="path-1"
                        d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                        transform="translate(0 -0.12)"
                      ></path>
                    </svg>
                  </div>
                  <div className="swiper-button-prev-tour">
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 26.07 21.19"
                    >
                      <title>next</title>
                      <path
                        id="path-1"
                        d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                        transform="translate(0 -0.12)"
                      ></path>
                    </svg>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="swiper-pagination"></div>
          )}
        </>
      ) : (
        <div className="react-loader">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SwiperMain;
